import { useCallback, useEffect, useRef, useState } from 'react';
import { adminRequest } from '../api';

export default function useManualLiveTiming(documentId, active) {
  const [data,setData] = useState(null), [error,setError] = useState(''), [busy,setBusy] = useState(false);
  const state = useRef(null), writing = useRef(null), generation = useRef(0), currentId = useRef(documentId);
  const path = `/admin/productions/${encodeURIComponent(documentId)}/schedule/live-timing`;
  const adopt = useCallback(d => { const next={...d,receivedAt:Date.now()}; state.current=next; setData(next); },[]);
  const refresh = useCallback(async () => {
    const token = ++generation.current;
    try {
      const d = await adminRequest(path);
      if (token === generation.current && !writing.current) { adopt(d); setError(''); }
    } catch (e) { if (token === generation.current) setError(e.message.replace(/\s*\(HTTP.*$/, '')); }
  },[path,adopt]);
  useEffect(() => { currentId.current=documentId; generation.current++; state.current=null; writing.current=null; setBusy(false); setData(null); setError(''); },[documentId]);
  useEffect(() => {
    if (!active) return undefined;
    refresh();
    const focus = () => { if (document.visibilityState === 'visible' && !writing.current) refresh(); };
    window.addEventListener('focus',focus);
    const timer = window.setInterval(focus,30000);
    return () => { generation.current++; window.removeEventListener('focus',focus); window.clearInterval(timer); };
  },[active,refresh]);
  const save = async body => {
    if (writing.current || !state.current || state.current.canEdit === false) return false;
    const operation={id:documentId};
    writing.current=operation; setBusy(true); setError(''); generation.current++;
    const id=documentId;
    try {
      const d = await adminRequest(path,{method:'PUT',body:{revision:state.current.revision,...body}});
      if (currentId.current === id && writing.current === operation) { adopt(d); return true; }
      return false;
    } catch (e) {
      if (currentId.current === id && writing.current === operation) setError(e.message.replace(/\s*\(HTTP.*$/, ''));
      // No automatic write retry: a lost response may already have saved Start/Complete.
      return false;
    } finally { if(writing.current===operation) { writing.current=null; setBusy(false); } }
  };
  return {data,error,busy,save,refresh};
}